export const PageNotFoundErrorCode = 404

export default class PageNotFoundError extends Error {
  constructor(e = 'Page non trouvée') {
    super(e)
    this.originalError = e
    this.name = 'PageNotFoundError'
    this.type = PageNotFoundErrorCode
  }
}
